<template>
  <table class="datatable table table-striped primary dataTable no-footer">
    <thead>
      <tr>
        <th>{{ $t('Common.item') }}</th>
        <th>{{ $t('Common.quantity') }}</th>
        <th v-if="showRebate" class="a-r">{{ $t('Common.rebate') }}</th>
        <th v-if="showDiscounts" class="a-r">{{ $t('Common.discount') }}</th>
        <th v-if="showPrices" class="a-r">{{ $t('Common.total') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in visible">
        <template v-if="item.type == 0">
          <td v-if="checkEditable(item)">
            <i class="fa fa-angle-right mleft-5 mright-5" aria-hidden="true"></i> <a v-on:click="emitItemClick(item)">{{ item.name }}</a>
          </td>
          <td v-else><i class="fa fa-angle-right mleft-5 mright-5" aria-hidden="true"></i> {{ item.name }}</td>

          <td v-if="item.cancelled">
            {{ $t('Common.cancelled') }}
          </td>
          <td v-else>
            <div class="btn" @click="addQty(item, -1)" v-if="checkEditable(item)">-</div>
            {{ formatAmount(item) }}
            <div class="btn" @click="addQty(item, +1)" v-if="checkEditable(item)">+</div>
          </td>
          <td v-if="showRebate" class="a-r nowrap">{{ item.rebate | formatCurrency }}</td>
          <td v-if="showDiscounts" class="a-r nowrap">{{ item.discount | formatPercent }}</td>
          <td v-if="showPrices" class="a-r nowrap">{{ totalItemPrice(item) | formatCurrency }}</td>
        </template>
        <template v-if="item.type == 1">
          <td :colspan="colspan" class="cart-title" @click="showHide(item)" >
            <i v-if="expandable" :class="`far ${item.visible ? 'fa-minus-square' : 'fa-plus-square'}`"/>
            {{ item.text }}
            {{ item | formatColor }}
          </td>
          <td v-if="showPrices" class="cart-title a-r nowrap">
            <template v-if="!item.visible && expandable">
              {{ totalItemPrice(item) | formatCurrency }}
            </template>
          </td>
        </template>
      </tr>
      <template v-if="showPrices">
        <tr v-if="tax > 0" class="bold b_t">
          <td>{{ $t('Common.orderPrice') }}</td>
          <td :colspan="colspan" class="a-r nowrap">{{ netamount | formatCurrency }}</td>
        </tr>
        <tr v-if="tax > 0" class="bold">
          <td>{{ $t('Common.vat') }}</td>
          <td :colspan="colspan" class="a-r nowrap">{{ tax | formatCurrency }}</td>
        </tr>
        <tr class="bold b_t">
          <td>{{ $t('Common.total') }}</td>
          <td :colspan="colspan" class="a-r nowrap">{{ total | formatCurrency }}</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    netamount: {
      type: Number
    },
    tax: {
      type: Number
    },
    total: {
      type: Number
    },
    showDiscounts: {
      type: Boolean,
      default: false
    },
    showRebate: {
      type: Boolean,
      default: false
    },
    showPrices: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    suffixFields: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    expandable() {
      if (this.$root.isEmbeddedMode) {
        return false;
      }
      return this.$root.features.collapsableCart || false;
    },
    colspan() {
      return 2 + (this.showDiscounts ? 1 : 0) + (this.showRebate ? 1 : 0);
    },
    visible() {
      if (!this.expandable) {
        return this.items.filter(item => item !== null);
      }
      const r = [];
      let section = null;
      for (let x of this.items.filter(item => item !== null)) {
        if (x.type == 1) {
          section = x;
          r.push(x);
          continue;
        }

        if (section && section.visible !== true) {
          continue
        }

        r.push(x);
      }
      return r;
    }
  },
  filters: {
    formatColor(val) {
      // Workaround - working direclty with val.formValues breaks the component
      let formValues = Object.assign({}, val.formValues);
      return typeof formValues.color == 'undefined' ? '' : '(' + this.$t('Common.color') + ': ' + formValues.color + ')';
    }
  },
  methods: {
    showHide(item) {
      item.visible = !item.visible;
      this.items = [...this.items];
      this.$forceUpdate();
    },
    totalItemPrice(item) {
      if (item.type == 1) {
        let total = 0;
        let skip = true;
        for (let x of this.items.filter(item => item !== null)) {
          if (item !== x && skip) {
            continue;
          }
          if (skip) {
            skip = false;
            continue;
          }
          if (x.type == 1) {
            break;
          }
          total += this.totalItemPrice(x);
        }
        return total;
      }

      return item.amount * (item.sellingprice - item.rebate) * (1 - item.discount / 100) * (1 - item.discount2 / 100);
    },
    checkEditable(item) {
      if (!this.editable || item === null) {
        return false;
      }

      return (typeof item.section == 'string') && item.section == 'addons';
    },
    emitItemClick(item) {
      this.$emit('itemclick', item);
    },
    formatAmount(item) {
      switch (item.unit) {
        case 'GRM':
          if (item.amount === 1) {
            return '/' + this.$t('Units.GRM');
          }
          return item.amount + ' ' + this.$t('Units.GRM');
        case 'C62':
          return item.amount + ' ' + this.$t('Units.C62');
      }

      return item.amount;
    },
    addQty(item, amount) {
      item.amount = Math.max(0, item.amount + amount);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.$emit('change', item), 1000);
    }
  }
}
</script>
<style scoped>
  .btn {
    display: inline-block;
    padding: 8px;
  }
  .cart-title {
    cursor: pointer;
  }
</style>
